<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label="iv" class="page" epub:type="pagebreak" id="piv" role="doc-pagebreak"></span>The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2022 by The University of Chicago</p>
<p class="crt">All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 East 60th Street, Chicago, IL 60637.</p>
<p class="crt">Published 2022</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">31 30 29 28 27 26 25 24 23 22     1 2 3 4 5</p>
<p class="crtf">ISBN-13: 978-0-226-82129-0 (cloth)</p>
<p class="crt">ISBN-13: 978-0-226-82130-6 (paper)</p>
<p class="crt">ISBN-13: 978-0-226-82131-3 (e-book)</p>
<p class="crt">DOI: <a class="url" href="https://doi.org/10.7208/chicago/9780226821313.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226821313.001.0001</a></p>
<p class="crtf">The University of Chicago Press gratefully acknowledges the generous support of New York University and the Abraham and Rebecca Stein Faculty Publication Fund toward the publication of this book.</p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Guillory, John, author.</p>
<p class="cip">Title: Professing criticism : essays on the organization of literary study / John Guillory.</p>
<p class="cip">Description: Chicago : University of Chicago Press, 2022. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: LCCN 2022012453 | ISBN 9780226821290 (cloth) | ISBN 9780226821306 (paperback) | ISBN 9780226821313 (e-book)</p>
<p class="cip">Subjects: LCSH: Criticism—Study and teaching. | Humanities—Study and teaching. | Literature—History and criticism.</p>
<p class="cip">Classification: LCC PN94.2.G85 2022 | DDC 801/.95071—dc23/eng/20220510</p>
<p class="cip">LC record available at <a class="url" href="https://lccn.loc.gov/2022012453" target="_blank">https://lccn.loc.gov/2022012453</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of ANSI<span class="sm">/</span>NISO Z39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-guillory-0004.vue?1c07fd28